import { apiClient, endpoints, unwrap } from '@core/api';

function normalizeReferralAvailability(input = {}) {
  return {
    loyalty_exists: Boolean(input.loyalty_exists),
    loyalty_id: String(input.loyalty_id || ''),
    referral_addon_enabled: Boolean(input.referral_addon_enabled),
    show_referral_code_input: Boolean(input.show_referral_code_input),
  };
}

export async function getReferralAvailability() {
  const raw = await apiClient.get(endpoints.crm.referralAvailability);
  const { data } = unwrap(raw);
  return normalizeReferralAvailability(data || raw);
}
